// src/hooks/usePermissions.js
import { useAuth } from '../context/AuthContext';
import { ROLE_CONFIG } from '../config/roleConfig';

export const usePermissions = () => {
  const { selectedRole } = useAuth();
  const config = ROLE_CONFIG[selectedRole] || {};

  const hasPermission = (resource, action) => {
    return config.permissions?.[resource]?.[action] || false;
  };

  const getScope = (resource) => {
    return config.permissions?.[resource]?.scope || 'none';
  };

  const canView = (resource) => hasPermission(resource, 'view');
  const canCreate = (resource) => hasPermission(resource, 'create');
  const canEdit = (resource) => hasPermission(resource, 'edit');
  const canDelete = (resource) => hasPermission(resource, 'delete');

  return {
    role: selectedRole,
    config,
    hasPermission,
    getScope,
    canView,
    canCreate,
    canEdit,
    canDelete,
    sidebarItems: config.sidebarItems || []
  };
};